import React, { useEffect, useState } from "react"
import Sidebar from "../components/sidebar"
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "../axiosInstance";

import Topbar from "../components/topbar";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Pagination from "../components/Pagination";
import { errorMessage } from "../hooks/UserLogs";
export default function Agent() {
  const [view, setView] = useState(false);
  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [ListAgents, setListAgents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [firstNamelUp, setFirstNameUp] = useState("");
  const [lastNamelUp, setLastNameUp] = useState("");
  const [middleNamelUp, setMiddleNameUp] = useState("");
  const [profilelUp, setProfilelUp] = useState("");
  const [addressUp, setAddressUp] = useState("");
  const [phoneUp, setPhoneUp] = useState("");
  const [emailUp, setEmailup] = useState("");
  const [genderUp, setGenderUp] = useState("");
  const [errorForm, setErrorForm] = useState({});
  const [errMsg, seterrMsg] = useState("Une erreure s'est produite!!");
  const [idUp, setIdUp] = useState(0);
  const [showError, setShowError] = useState(false);
  let header =
  {
    'Content-Type': 'application/json'
  };
  const handleClose = () => {
    setErrorForm({});
    setFirstNameUp("")
    setLastNameUp("")
    setMiddleNameUp("")
    setGenderUp("");
    setEmailup("")
    setIdUp(0);
    setPhoneUp("")
    setView(false)

  }
  const viewClose = () => {
    setView(false)
  }
  const viewOpen = () => {
    setView(true)
  }
  const handleCloseError = () => {
    setShowError(false);
  }

  const viewUpdate = (id, firstName, lastName, middleName, profile, address) => {
    setIdUp(id);
    setAddressUp(address);
    setMiddleNameUp(middleName);
    setLastNameUp(lastName);
    setFirstNameUp(firstName);
    setProfilelUp(profile);
    setView(true)
  }
  const updateForm = () => { }

  const bUrl = process.env.REACT_APP_B_URL;

  const [searchParams, setSearchParams] = useSearchParams();
  const idAgency = searchParams.get("idAgency");
  const navigate = useNavigate();
  const getListAgents = async (email, phone, code) => {
    let ulr = "/customer-wallet/find-all-agents?page=" + currentPage + "&limit=10";
    if (idAgency != undefined) {
      ulr = ulr + "&idAgency=" + idAgency;
    }

    setCode(code);
    setEmail(email);
    setPhone(phone);
    if (code != '' | phone != '' | email != '') {
      ulr = "/customer-wallet/find-all-agents?page=" + currentPage + "&limit=10";
      // if (email != '') {
      //   ulr += "&email=" + email;
      // }
      // if (code != '') {
      //   ulr += "&code=" + code;
      // }
      if (phone != '') {
        ulr += "&phone=" + phone;
      }
      
    }

    const response = await axios.get(bUrl + ulr).catch((err) => {

      setIsLoading(false)

      if (err?.response?.status == 401 || err?.response?.status == 403) {
        seterrMsg("Vous n'étes pas autorisé à faire cette opération!!")
        setShowError(true);
      } else {
        let msg = errMsg + ' ' + err?.response?.status ? (err?.response?.status) : '' ? (err?.response?.status) : '';
        seterrMsg(msg);
        setShowError(true);
      }

    });

    if (response) {
      if (response.status == 401) {
        navigate('/backoffice/login');
      }

      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        seterrMsg(msg);
        setShowError(true);
      } else {
        setListAgents(response.data.body);
        setTotalPage(response.data.totalPage);
        setCurrentPage(response.data.currentPage);
      }

      setIsLoading(false);
    }
  }
  const updateCustomer = () => {
    let error = {};
    let isvalid = true;

    if (firstNamelUp == "") {
      error.firstNamelUp = "Field is required!";
      isvalid = false;
    }
    if (lastNamelUp == "") {
      error.lastNamelUp = "Field is required!";
      isvalid = false;
    }

    if (addressUp == "") {
      error.addressUp = "Field is required!";
      isvalid = false;
    }
    if (profilelUp == "") {
      error.profilelUp = "Field is required!";
      isvalid = false;
    }

    setErrorForm(error);
    if (isvalid) {
      setIsLoading(true);
      axios.put(bUrl + "/customer-wallet/update-by-staff",

        //birthDay: birthDay,
        {
          "id": idUp,
          "firstName": firstNamelUp,
          "lastName": lastNamelUp,
          "middleName": middleNamelUp,
          "profile": profilelUp,
          "address": addressUp,
        }


        , { header: header })
        .then(function (response) {
          handleClose()
          if (response?.data?.isError) {
            const msg = errorMessage(response?.data?.code)
            seterrMsg(msg);
            setShowError(true);
          }
          else {
            getListAgents(email, phone, code);
          }

          setIsLoading(false)

        })
        .catch(function (error) {
          setIsLoading(false)

          console.log(error);
          setShowError(true);
        });
    }
  }

  const postCutomers = async () => {

  }
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }
  useEffect(() => {
    if (sessionStorage.getItem("name") === '' || sessionStorage.getItem("name") === null) {
      //console.log("----------GO GO GO ------------")
      navigate('/backoffice/login');
    }
    getListAgents(email, phone, code);
  }, [currentPage])

  return (
    <div className="App list-page agent-page">
      <div className="">


        <Sidebar />
        <section className="home ">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="table-content mt-2 p-2 text d-flex justify-content-between align-items-start">
                <div className="list-page-header"><div className='fw-bold'>Marchand</div></div>
                <Topbar />
              </div>
              <div className="list-filter-card mt-3">
                <div className="list-filter-toolbar">
                  <div className="list-filter-fields">
                  <div className="list-field">
                    <label htmlFor="exampleInputEmail1">Email</label>
                    <input type="email" onChange={(e) => getListAgents(e.target.value, phone, code)} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" />
                  </div>
                  <div className="list-field">
                    <label htmlFor="phone">Phone</label>
                    <input type="text" onChange={(e) => getListAgents(email, e.target.value, code)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                  </div>
                  <div className="list-field">
                    <label htmlFor="code">Code</label>
                    <input type="text" onChange={(e) => getListAgents(email, phone, e.target.value)} className="form-control" id="code" aria-describedby="Phone" placeholder="Code" />
                  </div>
                  </div>
                </div>
              </div>
              <div className="list-table-wrap mt-3 p-3">


                {/* <button onClick={() => viewOpen()}>

                  <i className='bx bxs-plus-circle icon'></i>
                </button> */}
                {/* <a href="/Home/Create" className="btn btn-primary mb-1"> </a> */}
                <div className="table-responsive">
                  {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
                    <table className="table list-table text mb-0">
                      <thead>
                        <tr>

                          <th scope="col">Id</th>
                          <th scope="col">Prénom</th>
                          <th scope="col">Deuxieme Nom</th>
                          <th scope="col">Nom</th>
                          <th scope="col">Téléphone</th>
                          <th scope="col">Date</th>

                          <th></th>
                          <th></th>

                        </tr>
                      </thead>

                      <tbody>
                        {ListAgents.length > 0 ? ListAgents.map((a, i) => {
                          return <tr key={i}>
                            <td>{i}</td>
                            <td>{a.firstName}</td>
                            <td>{a.middleName}</td>
                            <td>{a.lastName}</td>
                            <td>{a.phone}</td>
                            <td>{formatDate(a.createdDate)}</td>
                            <td>
                              <div className="list-table-actions">
                                <Link to={"/accountingOpByCustomer/" + a.fkIdAccounting}><i className='bx bx-folder-open' title="Opérations"></i></Link>
                                <Link to={"/customers/" + a.idCustomerWallet}><i className='bx bx-notepad' title="Détails"></i></Link>
                                <i onClick={() => viewUpdate(a.idCustomerWallet, a.firstName, a.lastName, a.middleName, a.profile, a.address)} className='bx bx-edit-alt colore-icon' title="Update"></i>
                              </div>
                            </td>
                          </tr>
                        }) : <tr></tr>}
                      </tbody>

                    </table>
                  }
                </div>
                <Pagination totalPage={totalPage} setCurrentPage={setCurrentPage} currentPage={currentPage} />
              </div>

            </div>
          </div>
        </section>
      </div>
      <Modal show={view} onHide={handleClose} className="">
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Agency</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="form-group mb-2">
              <input type="text" placeholder="Prénom" name="firstname" className='form-control ' value={firstNamelUp} onChange={(e) => setFirstNameUp(e.target.value)} />
              {errorForm.firstNamelUp != "" && <p style={{ color: 'red' }}>{errorForm.firstNamelUp}</p>}
            </div>
            <div className="form-group mb-2">
              <input type="text" placeholder="Deuxième Nom" name="middlename" className='form-control ' value={middleNamelUp} onChange={(e) => setMiddleNameUp(e.target.value)} />
              {errorForm.middleNamelUp != "" && <p style={{ color: 'red' }}>{errorForm.middleNamelUp}</p>}
            </div>
            <div className="form-group mb-2">
              <input type="text" placeholder="Nom" name="lastname" className='form-control ' value={lastNamelUp} onChange={(e) => setLastNameUp(e.target.value)} />
              {errorForm.lastNamelUp != "" && <p style={{ color: 'red' }}>{errorForm.lastNamelUp}</p>}
            </div>
            <div className="form-group mb-2">
              <input type="text" placeholder="Adresse" name="name" className='form-control ' value={addressUp} onChange={(e) => setAddressUp(e.target.value)} />
              {errorForm.addressUp != "" && <p style={{ color: 'red' }}>{errorForm.addressUp}</p>}
            </div>

            <div className="form-group">
              <select className="form-control" id="exampleFormControlSelect1" placeholder='Gender' onChange={(e) => setProfilelUp(e.target.value)} value={profilelUp}>
                <option >Sélectionner profil</option>

                <option value={'CUSTOMER'} selected={profilelUp == "CUSTOMER"} >Customer</option>
                <option value={'AGENT'} selected={profilelUp == "AGENT"} >Marchand</option>

              </select>
              {errorForm.profilelUp != "" && <p style={{ color: 'red' }}>{errorForm.profilelUp}</p>}
            </div>





          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {isLoading ?
            <img src='../Custom.svg' width="30%" />
            :
            <Button variant="primary" onClick={updateCustomer}>
              Modifier
            </Button>

          }
        </Modal.Footer>
      </Modal>

      {/* =============================================error=============================== */}
      <Modal show={showError} onHide={handleCloseError} className="">
        <Modal.Header closeButton className="bg-danger">
          <Modal.Title>ERROR</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseError}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
